// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThePlayerScoreRow_wrapper_33bVv","content":"ThePlayerScoreRow_content_3RVAv","nameText":"ThePlayerScoreRow_nameText_285Il"};